import { CreateLiEvent, LiEvent } from "../schema/liEvent";

/** A saved event as the source form edits it, with nullable database values normalised. */
export const formValuesFromLiEvent = (liEvent: LiEvent): CreateLiEvent => ({
	id: liEvent.id,
	name: liEvent.name,
	type: liEvent.type,
	searchTerm: liEvent.searchTerm ?? "",
	searchTermInTitle: liEvent.searchTermInTitle,
	locationList: liEvent.locationList || [],
	industryList: liEvent.industryList || [],
	titleKeyword: liEvent.titleKeyword ?? "",
	firstConnection: liEvent.firstConnection ?? false,
	secondConnection: liEvent.secondConnection ?? false,
	thirdConnection: liEvent.thirdConnection ?? false,
	now: liEvent.now,
	atEventDate: liEvent.atEventDate,
	xDaysBeforeEvent: liEvent.xDaysBeforeEvent,
	alsoPastEvents: liEvent.alsoPastEvents,
	fromOrganization: liEvent.fromOrganization,
	eventUrls: liEvent.liEventEntries?.map((liEventEntry) => liEventEntry.url),
	plannedScrapingUserId: liEvent.plannedScrapingUserId,
});
